import { cn } from '@ngg/storefront-utils';
import Link from '../../Link/Link';
import { usePathname } from 'next/navigation';
import { NavigationFragment } from '@business/gql/graphql';

type MobileMenuPageLinkProps = {
  link?: NavigationFragment | null;
  locale: string;
  onClose: () => void;
  className?: string;
};

export default function MobileMenuPageLink({
  link,
  onClose,
  locale,
  className,
}: MobileMenuPageLinkProps) {
  const pathname = usePathname();

  if (!link) return null;

  const isCurrentPage = pathname.endsWith(link?.page?.slug || '');

  const buttonAndLinkClassName = cn(
    'flex w-full items-center justify-between px-4 py-2 text-left',
    isCurrentPage && 'underline',
    className,
  );

  return (
    <div>
      <Link
        className={buttonAndLinkClassName}
        locale={locale}
        onClick={() => onClose()}
        href={link?.page?.slug || ''}>
        {link.title}
      </Link>
    </div>
  );
}
